var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreAuthB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.728 4.87821L15.4558 2.60599C15.3523 2.50335 15.2126 2.44549 15.0669 2.44488H12.2891V1.36155C12.2966 1.06963 12.189 0.786484 11.9893 0.573353C11.7897 0.360222 11.5142 0.23424 11.2224 0.222656H6.68912C6.54653 0.228267 6.40651 0.262431 6.27737 0.323125C6.14822 0.38382 6.03256 0.469811 5.93725 0.576006C5.84193 0.682202 5.76889 0.806443 5.72245 0.941374C5.67601 1.0763 5.65712 1.21918 5.66689 1.36155V2.44488H2.93356C2.86045 2.44446 2.78797 2.45847 2.72028 2.48612C2.65259 2.51376 2.59103 2.5545 2.53912 2.60599L0.272449 4.87821C0.220959 4.93012 0.180223 4.99169 0.152576 5.05938C0.124929 5.12706 0.110915 5.19954 0.111337 5.27266V13.556C0.111337 13.8507 0.228401 14.1333 0.436774 14.3417C0.645148 14.55 0.927764 14.6671 1.22245 14.6671H16.778C17.0727 14.6671 17.3553 14.55 17.5637 14.3417C17.7721 14.1333 17.8891 13.8507 17.8891 13.556V5.2671C17.8885 5.12136 17.8306 4.98169 17.728 4.87821ZM6.778 1.33377H11.2224V2.44488H6.778V1.33377ZM16.778 7.44488H11.2224V8.5171H16.778V13.556H1.22245V8.5171H6.778V7.44488H1.22245V5.50043L3.16689 3.55599H14.8336L16.778 5.50043V7.44488Z",
    fill: "#02A0FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreAuthB);
export default __webpack_public_path__ + "static/media/pre-AuthB.155902d4da7db63ac26feeb25d115822.svg";
export { ForwardRef as ReactComponent };